import { render, staticRenderFns } from "./LmsCheckout.vue?vue&type=template&id=207f2071&scoped=true"
import script from "./LmsCheckout.vue?vue&type=script&lang=js"
export * from "./LmsCheckout.vue?vue&type=script&lang=js"
import style0 from "./LmsCheckout.vue?vue&type=style&index=0&id=207f2071&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f2071",
  null
  
)

export default component.exports